<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">Classic British Love Stories</p>
<p class="bk-subtitle">Wuthering Heights, Pride and Prejudice, Far from the Madding Crowd, and Jane Eyre</p>
<p class="publisher"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5b67e96d